import { TRootState } from 'Redux/Reducers';

export const getPurchase = (state: TRootState) => state.payment.purchase;
